import { Typography } from '@mui/material';
import ModalConfirmacao from '@/components/sessao/ModalConfirmacao';
import {action, computed, makeObservable, observable, reaction} from 'mobx';
import { inject, observer } from 'mobx-react';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';

class Signatario extends ReactComponent {
    // Objeto com o signatario selecionado
    signatarioSelecionado = { nome: '', cpf: '' };
    exibirLabel = true;
    modalConfirmacaoSignatarioOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            signatarioSelecionado: observable,
            exibirLabel: observable,
            modalConfirmacaoSignatarioOpen: observable,
            setExibicaoLabel: action,
            alterarSignatarioSelecionado: action,
            AbrirModalConfirmaSignatario: action,
            callbackCancelar: action,
            callbackConfirmarSignatario: action,
            registro: computed,
            opcoes: computed,
            opcaoSelecionada: computed
        });

        this.setExibicaoLabel(props.exibirLabel);

        this.atualizarSignatario();

        reaction(() => this.observableProps.cpfSignatario, () => this.atualizarSignatario());
    }

    setExibicaoLabel(exibirLabel) {
        if (exibirLabel !== undefined) {
            this.exibirLabel = exibirLabel;
        }
    }

    atualizarSignatario() {
        if (this.observableProps.cpfSignatario) {
            let signatario = this.signatarioCadastrado(this.observableProps.cpfSignatario);
            if (signatario) {
                this.alterarSignatarioSelecionado(signatario);
            }
        }
    }

    alterarSignatarioSelecionado(signatarioSelecionado) {
        this.signatarioSelecionado = signatarioSelecionado;
    }

    AbrirModalConfirmaSignatario = async (option) => {
        this.opcao = option;
        if (this.observableProps.assinada) {
            this.modalConfirmacaoSignatarioOpen = true;
        } else this.callbackAutoCompleteSignatario();
    };

    callbackCancelar = () => {
        this.modalConfirmacaoSignatarioOpen = false;
    };

    callbackConfirmarSignatario = async () => {
        this.modalConfirmacaoSignatarioOpen = false;
        this.callbackAutoCompleteSignatario();
    };

    renderModalConfirmaSignatario() {
        if (this.observableProps.assinada) {
            return (
                <ModalConfirmacao
                    open={this.modalConfirmacaoSignatarioOpen}
                    callbackConfirmar={this.callbackConfirmarSignatario}
                    callbackCancelar={this.callbackCancelar}
                    titulo={'Desbloquear assinatura?'}
                >
                    <Typography>Esta alteração vai desbloquear a assinatura. Confirma ?</Typography>
                </ModalConfirmacao>
            );
        } else return null;
    }

    get registro() {
        return this.observableProps.registro;
    }

    signatariosCadastrados() {
        return this.dominioStore.signatariosCadastradosOjc(this.sessaoStore.sessaoSelecionada.orgaoJudicante.sigla);
    }

    temSignatariosCadastrados() {
        return this.dominioStore.temSignatariosCadastradosOjc(this.sessaoStore.sessaoSelecionada.orgaoJudicante.sigla);
    }

    signatarioCadastradoDefault() {
        return this.dominioStore.signatarioCadastradoDefaultOjc(
            this.sessaoStore.sessaoSelecionada.orgaoJudicante.sigla
        );
    }

    signatarioCadastrado(cpf) {
        return this.signatariosCadastrados().find((signatario) => signatario.cpf === cpf);
    }

    callbackAutoCompleteSignatario = async () => {
        if (this.opcao && this.opcao.valor && this.opcao.valor.cpf !== this.signatarioSelecionado.cpf) {
            await this.observableProps.callbackAlterarCpfSignatario(this.opcao.valor.cpf);
        }
    };

    signatarioToOpcao(signatario) {
        return {
            texto: signatario.nome,
            valor: signatario
        };
    }

    get opcoes() {
        return this.signatariosCadastrados().map((signatario) => this.signatarioToOpcao(signatario));
    }

    get opcaoSelecionada() {
        return this.signatarioToOpcao(this.signatarioSelecionado);
    }

    render() {
        return (
            !this.temSignatariosCadastrados() || (
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    {this.exibirLabel && (
                        <Typography
                            variant="subtitle1"
                            color="primary"
                            style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        >
                            <b>{'Signatário'}</b>
                        </Typography>
                    )}
                    <div
                        style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                        id="iconeAdicionarMovimento"
                    >
                        <div style={{ width: '100%' }}>
                            <AutoComplete
                                title={this.observableProps.disabled ? '' : 'Selecione o signatário da certidão'}
                                value={this.signatarioSelecionado.nome || null}
                                options={this.opcoes}
                                desabilitarLimpar={true}
                                onChange={this.AbrirModalConfirmaSignatario}
                                disabled={this.observableProps.disabled}
                            />
                            {this.renderModalConfirmaSignatario()}
                        </div>
                    </div>
                </div>
            )
        );
    }
}

export default inject('stores')(observer(Signatario));
